import Model from '@/models/Model'

export default class HrEmployee extends Model {
    resource() {
        return 'hr_causal'
    }
}